// ======================================================================
// File:
// src/modules/service_crm/dashboard/components/CustomerSatisfactionChart.js
//
// Purpose:
// Customer Satisfaction Distribution
//
// Uses:
// DashboardCard
// ======================================================================

import React from "react";

import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
} from "recharts";

import DashboardCard
  from "./DashboardCard";

const COLORS = [
  "#2563eb",
  "#f59e0b",
  "#dc2626",
];

export default function CustomerSatisfactionChart({

  data = [],

  onSatisfactionClick,

}) {

  return (

    <DashboardCard

      title="Customer Satisfaction"

      subtitle="Satisfied / Neutral / Dissatisfied"

      height={450}

    >

      <ResponsiveContainer
        width="100%"
        height="90%"
      >

        <PieChart>

          <Pie
            data={data}
            dataKey="count"
            nameKey="label"
            innerRadius={70}
            outerRadius={120}
            paddingAngle={3}
            onClick={(row) =>
              onSatisfactionClick &&
              onSatisfactionClick(
                row.label
              )
            }
          >

            {data.map(
              (entry, index) => (

                <Cell
                  key={index}
                  fill={
                    COLORS[
                      index %
                      COLORS.length
                    ]
                  }
                />

              )
            )}

          </Pie>

          <Tooltip />

          <Legend />

        </PieChart>

      </ResponsiveContainer>

    </DashboardCard>

  );
}